import PropTypes from "prop-types";
import React from "react";

import ModalFormDropdown from "../../../components/form/ModalFormDropdown";

const ImportCsvColumnTypeSelector = ({ columnType, ...restProps }) => (
  <ModalFormDropdown allowSearch value={columnType} {...restProps} />
);

ImportCsvColumnTypeSelector.propTypes = {
  columnType: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default ImportCsvColumnTypeSelector;
